import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CoreModule } from "@modules/core/core.module";
import { SharedPaymentsModule } from "@modules/+new/payments/shared-payments/shared-payments.module";
import { UniversalModalModule } from "@modules/+new/shared/universal-modal/universal-modal.module";
import { ManualDepositReminderComponent } from "@modules/+new/payments/features/fiat-deposit/modules/manual-deposit/manual-deposit-reminder/manual-deposit-reminder.component";
import { ManualDepositInstructionsComponent } from "@modules/+new/payments/features/fiat-deposit/modules/manual-deposit/manual-deposit-instructions/manual-deposit-instructions.component";
import { DepositInstructionsComponent } from "@modules/+new/payments/features/fiat-deposit/modules/manual-deposit/manual-deposit-instructions/components/deposit-instructions/deposit-instructions.component";
import { DepositInstructionsTileComponent } from "@modules/+new/payments/features/fiat-deposit/modules/manual-deposit/manual-deposit-instructions/components/deposit-instructions/deposit-instructions-tile/deposit-instructions-tile.component";
import { A11yModule } from "@angular/cdk/a11y";

@NgModule({
	imports: [CommonModule, CoreModule, SharedPaymentsModule, UniversalModalModule, A11yModule],
	declarations: [
		ManualDepositReminderComponent,
		ManualDepositInstructionsComponent,
		DepositInstructionsComponent,
		DepositInstructionsTileComponent
	],
	exports: [ManualDepositReminderComponent, ManualDepositInstructionsComponent]
})
export class ManualDepositModule {}
